module.exports = __webpack_public_path__ + "img/icon-reports.0d31559e.svg";